import saveMapDealPartNumbers from 'api/saveMapDealPartNumbers';
import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { reset } from 'redux/modules/master/pipelinePartnumberMapper/slice';

const useSave = (): [(form: any) => Promise<void>, boolean] => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const save = useCallback(
    async (form) => {
      setLoading(true);

      try {
        await saveMapDealPartNumbers(form);

        dispatch(reset());
      } catch {
        setLoading(false);
      }
    },
    [dispatch]
  );

  return [save, loading];
};

export default useSave;
